import * as types from '@/store/mutationTypes';
import { getField, updateField } from 'vuex-map-fields';

const state = {
  daysIntoFuture: 5,
};

const getters = {
  getField,
  daysIntoFuture: spaceTimeState => spaceTimeState.daysIntoFuture,
};

const mutations = {
  [types.UPDATE_DAYS_INTO_FUTURE](loadState, newVal) {
    loadState.daysIntoFuture = newVal; // eslint-disable-line no-param-reassign
  },
  updateField,
};

const actions = {
  setDaysIntoTheFuture({ commit }, newVal) {
    commit(types.UPDATE_DAYS_INTO_FUTURE, newVal);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};



// WEBPACK FOOTER //
// ./src/store/modules/spaceTime.js